// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"Sidebar---1SmoN","AboutCard":"AboutCard---2xsSa","SegmentRow":"SegmentRow---9Pr_L"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/style.styl
// module id = EtIs
// module chunks = 89